/** Represent a week in a calendar month. */
export class CalendarWeek {
    constructor(weekNumber, days) {
        this.days = days;
        this.weekNumber = weekNumber;
    }
}
//# sourceMappingURL=CalendarWeek.js.map